import { ConsultantEventType } from "@bonliva-crm/graphql";

export enum MainFilterType {
  Call = ConsultantEventType.Call,
  Noanswer = ConsultantEventType.Noanswer,
  Email = ConsultantEventType.Email,
  SMS = ConsultantEventType.SMS,
  Comment = ConsultantEventType.Comment,
  Interest = ConsultantEventType.Interest
}

export enum OtherFilterType {
  GDPR = ConsultantEventType.GDPR,
  QualityUpdate = ConsultantEventType.QualityUpdate,
  Reminder = ConsultantEventType.Reminder,
  Registered = ConsultantEventType.Registered,
  SystemLog = ConsultantEventType.SystemLog,
  ConsultantApp = ConsultantEventType.ConsultantApp,
  WelcomeEmail = ConsultantEventType.WelcomeEmail,
  UserSettings = ConsultantEventType.UserSettings
}

export type FilterType = `${MainFilterType}` | `${OtherFilterType}`;
